import { useState } from "react";
import { useSelector } from "react-redux";
import { getLocalDesktopTrack } from "../../../base/tracks/functions.any";
const useShareScreenController = () => {
    const [permissionGranted, setPermissionGranted] = useState(false);
    const [scale, setScale] = useState();
    // @ts-expect-error
    if (!window.CaptureController?.prototype.sendWheel) {
        return {
            controllable: false,
            permissionGranted: false,
            zoomOut: () => { },
            zoomIn: () => { },
            onWheel: () => { },
        };
    }
    else {
        // @ts-expect-error
        const CaptureController = window.CaptureController;
        const localDesktopTrack = useSelector((state) => getLocalDesktopTrack(state['features/base/tracks']));
        const { controller } = localDesktopTrack?.jitsiTrack || { controller: null };
        try {
            controller.getZoomLevel();
        }
        catch (error) {
            return {
                controllable: false,
                permissionGranted: false,
                zoomOut: () => { },
                zoomIn: () => { },
                onWheel: () => { },
            };
        }
        if (controller) {
            controller.oncapturedzoomlevelchange = () => {
                setScale(controller.getZoomLevel());
            };
        }
        if (!scale)
            setScale(controller.getZoomLevel());
        // const controller = undefined;
        // console.log("===========> controller",controller)
        // return {
        //     controllable: !!controller,
        //     sendWheel: controller?.sendWheel,
        //     getSupportedZoomLevels: controller?.getSupportedZoomLevels,
        //     getZoomLevel: controller?.getZoomLevel,
        //     setZoomLevel: controller?.setZoomLevel
        // }
        async function maybeAskForPermission() {
            if (!controller || permissionGranted) {
                return;
            }
            await controller.sendWheel({});
            setPermissionGranted(true);
        }
        function translateCoordinates(video, offsetX, offsetY) {
            const previewDimensions = video.getBoundingClientRect();
            // @ts-expect-error
            const trackSettings = video.srcObject?.getVideoTracks()[0].getSettings();
            const x = (trackSettings.width * offsetX) / previewDimensions.width;
            const y = (trackSettings.height * offsetY) / previewDimensions.height;
            return [Math.floor(x), Math.floor(y)];
        }
        async function onWheel(event) {
            const video = document.getElementById("largeVideo");
            if (video) {
                const [x, y] = translateCoordinates(video, event.offsetX, event.offsetY);
                const [wheelDeltaX, wheelDeltaY] = [-event.deltaX, -event.deltaY];
                try {
                    await controller.sendWheel({ x, y, wheelDeltaX, wheelDeltaY });
                }
                catch (error) {
                    console.log("[Wheel Error]: ", error);
                }
            }
        }
        ;
        async function updateZoomLevel(zoomLevel) {
            await maybeAskForPermission();
            await controller.setZoomLevel(zoomLevel);
            setScale(zoomLevel);
        }
        const zoomOut = () => {
            const newZoomLevel = CaptureController.getSupportedZoomLevels()
                .toReversed()
                .find((zoomLevel) => zoomLevel < controller.getZoomLevel());
            if (newZoomLevel)
                updateZoomLevel(newZoomLevel);
        };
        const zoomIn = () => {
            const newZoomLevel = CaptureController.getSupportedZoomLevels()
                .find((zoomLevel) => zoomLevel > controller.getZoomLevel());
            if (newZoomLevel)
                updateZoomLevel(newZoomLevel);
        };
        return {
            controllable: !!controller,
            permissionGranted,
            controller,
            zoomOut,
            zoomIn,
            onWheel,
            scale
        };
    }
};
export default useShareScreenController;
